import { NostoListing } from '@theme/nosto-search-engine';

/**
 * Nosto Category Merchandising over the natively rendered collection grid.
 *
 * Everything generic (request state, timeout, staleness guard, reorder, dynamic
 * card backfill) lives in `NostoListing`; this element only says which category
 * it is asking for. See `nosto-search-engine.js` for the whole contract.
 */
class NostoCollection extends NostoListing {
  get nostoLabel() {
    return 'nosto-collection';
  }

  get nostoTrack() {
    return 'category';
  }

  /**
   * Reads the category from the tagging block rendered by the Nosto app embed.
   *
   * `categoryPath` does not narrow the query — the id alone already identifies
   * the category — but it is what Nosto puts in the impression beacon's
   * metadata. Without it the beacon carries an id and no name, which is why
   * nothing showed up in the dashboard (verified on the preview 2026-08-14:
   * same 12 hits either way, `metadata.category` present only with the path).
   */
  nostoTarget() {
    const categoryId = this.#tagging('.id');
    if (!categoryId) {
      this.debug('no Nosto category tagging on this page — keeping the native grid');
      return null;
    }

    /** @type {Record<string, unknown>} */
    const products = { categoryId };

    const categoryPath = this.#tagging('.category_string');
    if (categoryPath) products.categoryPath = categoryPath;

    return { products };
  }

  /**
   * @param {string} selector
   * @returns {string}
   */
  #tagging(selector) {
    return document.querySelector(`.nosto_category ${selector}`)?.textContent?.trim() ?? '';
  }
}

if (!customElements.get('nosto-collection')) {
  customElements.define('nosto-collection', NostoCollection);
}
